/* global http preloader scrollToElement */
const filterNews = {
	el: {
		body: document.body,
		container: document.querySelector('.js-filter-list-cards'),
		dropdowns: document.querySelector('.js-filter-sites'),
		grid: document.querySelector('.list-cards__list'),
		paginationContainer: document.querySelector('.js-filter-pagination')
	},

	vars: {
		currentPage: 1
	},

	fxRenderItems(data, element) {

		const items = data.items,
			grid = this.el.grid,
			pagination = this.el.paginationContainer

		grid.innerHTML = ''

		for (const item of items) {
			grid.innerHTML +=
				`
					<li class="list-cards__list-item">
						<a class="list-cards__list-link" href="${item.url}">
							<figure class="list-cards__list-figure"> 
								<img class="list-cards__list-figure-img"
									src="${item.src}" 
									alt="${item.headline}">
							</figure>
							<span class="list-cards__list-label label">${item.date}</span>
							<h3 class="list-cards__list-headline epsilon">${item.headline}</h3>
							<div class="list-cards__list-copy lambda">${item.copy}</div>
						</a>
					</li>
				`
		}

		pagination.innerHTML = ''

		for (let i = 0; i < data.pages.length; i++) {
			const active = !element && i === 0 || element && Number(element.textContent) === i + 1 ? 'active' : ''
			pagination.innerHTML += `<button class='filter__pagination-page js-pagination-item js-scrollto ${active}' data-scroll='grid' type='button'>${data.pages[i]}</button>`
		}

		for (const page of document.querySelectorAll('.js-pagination-item'))
			page.addEventListener('click', e => {
				if (!isNaN(e.currentTarget.textContent)) {
					this.fxFilterItems(e.currentTarget)
					scrollToElement.fxScrollTo(e)
				}
			})
	},

	fxFilterItems(element) {
		const container = this.el.container,
			isPageItemClicked = element && element.classList.contains('js-pagination-item'),
			currentPage = isPageItemClicked ? Number(element.textContent) : this.vars.currentPage

		const formData = {
			pageId: Number(container.dataset.id),
			currentPage: currentPage,
			siteId: Number(this.el.dropdowns.value),
			language: this.el.body.dataset.language
		}

		const callback = (response, data) => {
			preloader.fxPreloaderRemove(container)

			//TODO error 500
			const error = () => {}

			switch (response.status) {
				case 200:
					this.fxRenderItems(data, element)
					break
				case 500:
					error()
					break
			}
		}

		preloader.fxPreloaderAdd(container)
		http.fxPost(container.dataset.endpoint, formData, callback)
	},

	events() {
		this.el.dropdowns.addEventListener('change', () => this.fxFilterItems())
	},

	init() {
		if (this.el.container) {
			this.events()
			this.fxFilterItems()
		}
	}
}

filterNews.init()